module.exports = __webpack_public_path__ + "img/logo.daf28f06.png";